import { render } from "./RouteIcon.vue?vue&type=template&id=3e6c501b"
const script = {}
script.render = render

export default script